import { Injectable } from "@angular/core";
import { chart, dateFormat } from "highcharts";
import { KpisComponent } from "../reports/kpis/kpis.component";
import { KpisV2Component } from "../reports/kpis-v2/kpis-v2.component";
import * as Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
HC_more(Highcharts);


@Injectable()
export class KPIChartService {
  chartName: string;
  chartHeight: number;
  chartDescription: string;

constructor() {
//   this.chartName = "KPI chart";
//   this.chartDescription = "This is a KPI chart.";
//   this.chartHeight = 300;
}

getChartOptions(component: KpisComponent, series: any[]): Highcharts.Options {
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      type: "pie",
      plotBorderWidth: null,
      plotShadow: false,
      marginRight:0
   },
   title: {
      text: ''
   },
   subtitle: {
   },
   xAxis: {
      title: {
          text: ''
      },
   },
   yAxis: {          
      title:{
         text: ''
      } 
   },
   plotOptions: {
      pie: {
         allowPointSelect: true,
         cursor: 'pointer',
         dataLabels: {
            enabled: true ,
            distance: -40,
            format: '<b> {point.percentage:.0f} '+ ' %',
            color:"#fff",
            style :{
              fontSize:'10px',
              textOutline: 'none'
            }
            

         },
         showInLegend: true
      }
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.point.name + '</b>: ' + this.y;
      }
    },
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      x: -150,
      symbolRadius: 0,
      symbolPadding: 10,
      itemMarginTop: 10,
    },
    credits: {
      enabled: false
  },
   series:series
};
  return kpiChartOptions;
}

getPieChartOptions(component: KpisComponent, series: any[]): Highcharts.Options {
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      type: "pie",
      plotBorderWidth: null,
      plotShadow: false,
      marginRight:0,
      events: {
        load: function () {
          this.setTitle({text: "Breaker Receipt  <br> Monitoring w.r.t  <br> Mechanical Sticker"});
          return;
        }
      },
   },
   title: {
    align: 'center',
    verticalAlign: 'middle',
    style:{
      fontSize: '8pt'
    }
   },
   subtitle: {
   },
   xAxis: {
      title: {
          text: ''
      },
   },
   yAxis: {          
      title:{
         text: ''
      } 
   },
   plotOptions: {
      pie: {
         allowPointSelect: true,
         cursor: 'pointer',
         innerSize: '60%',
         dataLabels: {
            enabled: true ,
            distance: -17,
            format: '<b> {point.percentage:.0f} '+ ' %',
            color:"#fff",
            style :{
              fontSize:'10px',
              textOutline: 'none'
            }
            

         },
         showInLegend: true
      }
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.point.name + '</b>: ' + this.y;
      }
    },
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      x: -150,
      symbolRadius: 0,
      symbolPadding: 10,
      itemMarginTop: 10,
    },
    credits: {
      enabled: false
  },
   series:series
};
  return kpiChartOptions;
}

getPieChartOptionsKPI( series: any[],type:string): Highcharts.Options {
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      type: "pie",
      plotBorderWidth: null,
      plotShadow: false,
      marginRight:0,
      events: {
        load: function () {
          this.setTitle({text: type});
          return;
        }
      },
   },
   title: {
    align: 'center',
    verticalAlign: 'middle',
    style:{
      fontSize: '8pt'
    }
   },
   subtitle: {
   },
   xAxis: {
      title: {
          text: ''
      },
   },
   yAxis: {          
      title:{
         text: ''
      } 
   },
   plotOptions: {
      pie: {
         allowPointSelect: true,
         cursor: 'pointer',
         innerSize: '60%',
         dataLabels: {
            enabled: true ,
            distance: -17,
            format: '<b> {point.percentage:.0f} '+ ' %',
            color:"#fff",
            style :{
              fontSize:'10px',
              textOutline: 'none'
            }
            

         },
         showInLegend: true
      }
    },
    tooltip: {
      formatter: function() {
        return  '<b>' + 'Total Panel Quantity' + '</b>: ' + this.point.y + ", " + '<b>' + 'Total Contractual Value' + '</b>: ' + this.point.x + '(minr)';
      }
    },
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      // x: -10,
      symbolRadius: 0,
      symbolPadding: 10,
      itemMarginTop: 10,
    },
    credits: {
      enabled: false
  },
   series:series
};
  return kpiChartOptions;
}

getPieChartOptions2(component: KpisComponent, series: any[],_typeNo): Highcharts.Options {
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      type: "pie",
      plotBorderWidth: null,
      plotShadow: false,
      marginRight:0,
      height: 250,  
      width: 500,
      events: {
        load: function () {
          if (_typeNo == 1) { this.setTitle({text: "CT last receipt w.r.t <br>  Requested line loading"}); }
          if (_typeNo == 2) { this.setTitle({text: "MB last receipt w.r.t <br>  Requested line loading"}); }
          if (_typeNo == 3) { this.setTitle({text: "CT last receipt w.r.t <br>  Actual line loading"}); }
          if (_typeNo == 4) { this.setTitle({text: "MB last receipt w.r.t <br>  Actual line loading"}); }
          return;
        }
      },
   },
   title: {
    // text: '',
    align: 'center',
    verticalAlign: 'middle',
    style:{
      fontSize: '8pt'
    }
    // y: 40
},
   subtitle: {
   },
   xAxis: {
      title: {
          text: ''
      },
   },
   yAxis: {          
      title:{
         text: ''
      } 
   },
   plotOptions: {
      pie: {
         allowPointSelect: true,
         cursor: 'pointer',
         innerSize: '60%',
         dataLabels: {
            enabled: true ,
            distance: -17,
            format: '<b> {point.percentage:.0f} '+ ' %',
            color:"#fff",
            style :{
              fontSize:'10px',
              textOutline: 'none'
            }
            

         },
         showInLegend: true
      }
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.point.name + '</b>: ' + this.y;
      }
    },
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      x: 10,
      symbolRadius: 0,
      symbolPadding: 10,
      itemMarginTop: 10,
    },
    credits: {
      enabled: false
  },
   series:series
};
  return kpiChartOptions;
}

getComboChartOptions(component: KpisV2Component, series: any[]): Highcharts.Options {
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      events: {
        load: function () {
        },
        render: function () {
          if (component != null) {
              if (component !== undefined && component !== undefined) {
                 
              }
          }
      }
      }
    },
  title: {
      text: '',
      style:{
        fontFamily:'abb-voice',
        fontSize:'10pt',
        fontWeight:'bold'
      }
  },
  subtitle: {
      text: ''
  },
  xAxis: { 
     type: 'datetime',
     labels: {
     format : '{value:%b %y}',
    }
  },

  yAxis: [{ // Primary yAxis
      labels: {
          style: {
              color: '#a9a9a9'
          }
      },
      title: {
          text: 'TPT+ DAYS',
          style: {
              color: '#262626'
          }
      },

  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: '#6e6e6e'
          }
      },
      labels: {
          style: {
              color: '#a9a9a9'
          }
      },
      opposite: true,

  }],
  credits: {
    enabled: false
  },
  tooltip: {
    split: false,
    formatter: function () {
      return Highcharts.dateFormat('%B, %Y', this.x) + '<br/>' + this.y
    }
  },
  legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      x: 10,
      symbolRadius: 0,
      symbolPadding: 10,
      itemMarginTop: 10,
     
  },
  plotOptions: {
    series: {
        connectNulls: true
    }
},
  series: series
  };
  return kpiChartOptions;
}
getBucketChartOptions(component: KpisV2Component, series: any[]): Highcharts.Options{
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      // type: "column",
      events: {
        load: function () {
        },
        render: function () {
          if (component != null) {
              if (component !== undefined && component !== undefined) {
                 
              }
          }
      }
      },
    },
  title: {
      text: '',
      style:{
        fontFamily:'abb-voice',
        fontSize:'10pt',
        fontWeight:'bold'
      }
  },
  subtitle: {
      text: ''
  },
  xAxis:
  {
    categories:["At Wearhouse","At Line","Internal Testing Time","At FAT","After FAT"],
    labels:{
      style:{
        color: '#6e6e6e'
      }
    }
  },

  yAxis: { 
      title: {
          text: '',
          style: {
              color: '#6e6e6e'
          }
      },
      labels: {
          style: {
              color: '#a9a9a9'
          }
      },

  },

  credits: {
    enabled: false
  },
  tooltip: {
    pointFormat: '{point.y}'
  },
  legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      x: 10,
      symbolRadius: 0,
      symbolPadding: 10,
      itemMarginTop: 10,
     
  },
  plotOptions: {
  column: {
  grouping: true
}
  
},
  series: series
  };
  return kpiChartOptions;
}

getWaterFallChartOptions(component: KpisV2Component, series: any[],_typeNo:number): Highcharts.Options{
  const service = this;
  const kpiChartOptions:Highcharts.Options = {
  chart: {
    type: 'waterfall',
    plotBorderWidth: null,
    plotShadow: false,
     marginRight:0,
    height: 250,  
    width: 500,
    events: {
      load: function () {
      }
    },
},

title: {
  text:'',
    style:{
      fontFamily:'abb-voice',
      fontSize:'10pt',
      fontWeight:'bold'
    }
},

xAxis: {
    type: 'category',
    labels: {
      rotation: 0,
      align: 'center'
  },
},

yAxis: {
    title: {
        text: ''
    }
},
credits: {
  enabled: false
},
legend: {
    enabled: false
},

tooltip: {
    pointFormat: '<b>{point.y}</b>'
},
plotOptions: {
  series: {
     dataLabels: {
        enabled: true ,
        inside: false,
        format: '{point.y} ',
        style :{
          fontSize:'8pt',
          fontFamily:'abb-voice',
          fontWeight:'normal',
          textOutline: 'none',
          color: '#262626'
        }
      }
      }
    },
series: series

};
return kpiChartOptions;
}

getTotalDataChartOptions(series: any[]): Highcharts.Options {
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      type: "column",
      plotBorderWidth: null,
    plotShadow: false,
     marginRight:0,
    height: 250,  
    width: 500,
      events: {
      },
    },
  title: {
      text: '',
      style:{
        fontFamily:'abb-voice',
        fontSize:'10pt',
        fontWeight:'bold'
      }
  },
  subtitle: {
      text: ''
  },
  xAxis:
  {
    // categories:["Total Panel Quantity","On Time Panel","Delayed Panel"],
    type:  'category',
    labels:{
      style:{
        color: '#6e6e6e',
        fontFamily:'abb-voice'
      }
    }
  },

  yAxis: { 
      title: {
          text: '',
          style: {
              color: '#6e6e6e',
              fontFamily:'abb-voice',
          }
      },
      labels: {
          style: {
              color: '#a9a9a9',
              fontFamily:'abb-voice',
          }
      },

  },

  credits: {
    enabled: false
  },
  tooltip: {
    pointFormat: '{point.y}',
    style:{
      fontFamily:'abb-voice'
    }
  },
  legend: {
      enabled: false
  },
  plotOptions: {
  column: {
  grouping: true,
  dataLabels: {
    enabled: true ,
    inside: false,
    format: '{point.y} ',
    style :{
      fontSize:'8pt',
      fontFamily:'abb-voice',
      fontWeight:'normal',
      textOutline: 'none',
      color: '#262626'
    }
  }
}
  
},
  series: series
  };
  return kpiChartOptions;
}
getPanelWiseChartOptions(series: any[]): Highcharts.Options {
  const kpiChartOptions:Highcharts.Options = {
    chart: {
      // type: "column",  
      plotBorderWidth: null,
    plotShadow: false,
     marginRight:0,
    height: 250,  
    width: 500,
      events: {
      },
    },
  title: {
      text: '',
      style:{
        fontFamily:'abb-voice',
        fontSize:'10pt',
        fontWeight:'bold'
      }
  },
  subtitle: {
      text: ''
  },
  xAxis:
  {
    categories:["ZN1","ZS9","ZS1","ZS1 DBB","ZS2"],
    // type:  'category',
    labels:{
      style:{
        color: '#6e6e6e',
        fontFamily:'abb-voice'
      }
    }
  },

  yAxis: { 
      title: {
          text: '',
          style: {
              color: '#6e6e6e',
              fontFamily:'abb-voice',
          }
      },
      labels: {
          style: {
              color: '#a9a9a9',
              fontFamily:'abb-voice',
          }
      },

  },

  credits: {
    enabled: false
  },
  tooltip: {
    pointFormat: '{point.y}',
    style:{
      fontFamily:'abb-voice'
    }
  },
  legend: {
    symbolRadius: 0,
    symbolPadding: 10,
    itemMarginTop: 10,
    enabled: true,
  },
  plotOptions: {
  column: {
  grouping: true,
  dataLabels: {
    enabled: true ,
    inside: false,
    format: '{point.y} ',
    style :{
      fontSize:'8pt',
      fontFamily:'abb-voice',
      fontWeight:'normal',
      textOutline: 'none',
      color: '#262626'
    }
  }
}
  
},
  series: series
  };
  return kpiChartOptions;
}
}